import { render, staticRenderFns } from "./EnacCustomAtplPhaseEditItems.vue?vue&type=template&id=63c85eb0"
import script from "./EnacCustomAtplPhaseEditItems.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplPhaseEditItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports